export const SUMA_ASEGURADA = '50000';
export const FORMATO_SUMA_ASEGURADA = 'S/ 50,000';
export const TIEMPO_AHORRO = '20';
export const PORCENTAJE_DEV = '200';

export const SUMA_ASEGURADA_B = '25000';
export const FORMATO_SUMA_ASEGURADA_B = 'S/ 25,000';
export const TIEMPO_AHORRO_B = '5';
export const PORCENTAJE_DEV_B = '100';

export const SUMA_ASEGURADA_OLD = '50000';
export const FORMATO_SUMA_ASEGURADA_OLD = 'S/ 50,000';
export const TIEMPO_AHORRO_OLD = '13';
export const PORCENTAJE_DEV_OLD = '150';